import { graphql } from "react-relay";

export const eventSummaryTimeFragments = {
  org: graphql`
    fragment EventSummaryTime_org on Org {
      id
      primaryOrgCalendar
    }
  `,
  event: graphql`
    fragment EventSummaryTime_event on Event {
      startTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
      endTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
      eventKey {
        externalEventId
      }
      eventFlexibilityErrorable {
        ... on EventFlexibilityNewList {
          list {
            flex
            flexString
          }
        }
      }
      recurrenceRules {
        firstInstanceStartTime {
          type
          dateOrDateTime
          timeZone
          millis
          offsetMinutes
        }
        timeZone
        interval {
          interval
          byDay
          bySetPos
          freqType
          count
          untilTime {
            type
            dateOrDateTime
            timeZone
            millis
            offsetMinutes
          }
        }
      }
      annotatedEvent {
        orgTags {
          tag
          state {
            active
            value
            subjectType
          }
        }
      }
    }
  `,
};
